const Mission = () => {
  return (
    <div className="bg-white py-10 px-4 sm:px-6 md:px-16 lg:px-24 mb-5">
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center md:items-start gap-6 md:gap-10">
        {/* Text Section */}
        <div className="flex-1">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-extrabold text-gray-900 mb-4 sm:mb-6 mt-6 sm:mt-10 text-center md:text-left">
            Mission
          </h2>
          <ul className="space-y-3 sm:space-y-4 text-gray-700 pl-0 sm:pl-0 text-sm sm:text-base leading-relaxed text-justify sm:text-left">
            {[
              {
                title: "Eco-Conscious Innovation",
                desc: "Develop sustainable, biotechnology-based solutions using probiotics, enzymes, and beneficial microbes."
              },
              {
                title: "Animal Health & Performance",
                desc: "Enhance immunity, growth, and feed efficiency in aquaculture, poultry, and livestock without relying on antibiotics or harmful chemicals."
              },
              {
                title: "Scientific Excellence",
                desc: "Back every product with rigorous research and manufacture through zero-emission, sustainable processes."
              },
              {
                title: "Real-World Impact",
                desc: "Collaborate with farmers and industry partners to ensure measurable, long-term benefits in animal care."
              },
              {
                title: "Customer-Centric Approach",
                desc: "Provide strong technical support, continuous knowledge-sharing, and practical solutions tailored to producers’ needs."
              },
              {
                title: "Ethics & Responsibility",
                desc: "Commit to ethical practices, sustainability, and redefining animal health for a safer, more responsible future."
              }
            ].map((item, idx) => (
              <li key={idx} className="flex items-start gap-3">
                {/* Green Tick */}
                <span className="mt-1 text-green-600">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" />
                  </svg>
                </span>
                <div>
                  <span className="font-semibold text-black text-justify">{item.title}:</span> <br />
                  {item.desc}
                </div>
              </li>
            ))}
          </ul>
        </div>

        {/* Image Section */}
        <div className="flex-1 flex justify-center items-start relative min-h-[300px] sm:min-h-[400px] md:min-h-[460px] mt-5 sm:mt-15">
          <div className="hidden lg:block h-[450px] w-[450px] border-[7px] rounded-[40px] border-rgba(205, 222, 222, 1)-300 absolute top-0 right-10 z-0" />
          <img
            src="/img/banner/mission_banner_img.png"
            alt="Mission visual"
            className="w-[250px] sm:w-[350px] md:w-[450px] h-auto relative z-10 object-contain mt-6 sm:mt-10"
          />
        </div>
      </div>
    </div>
  );
};

export default Mission;
